import { Select } from "antd";
import styled from "styled-components";

export const StyledAppSelect = styled(Select)`
    .ant-select-content {
        align-self: center !important;
    }
`;
